export interface CopyFieldMap {
  from: string;
  to: string;
}

export interface CopyOptionAlias {
  from: string;
  to: string;
}

export interface CopyActiveOptionMap extends CopyFieldMap {
  optionMap?: CopyOptionAlias[];
  numberTo?: string;
}

export interface CopyFromGroupConfig {
  sourceGroup: string;
  sourceLabel?: string;
  sourceIndexField?: string;
  /** Sin interruptor: copia sola al cargar y cuando cambia el grupo origen. */
  auto?: boolean;
  lockCopied?: boolean;
  allowOther?: boolean;
  otherValue?: string;
  otherLabel?: string;
  map?: CopyFieldMap[];
  copyActiveOption?: CopyActiveOptionMap[];
}

export function readCopyFromGroup(field: any): CopyFromGroupConfig | null {
  if (!field) return null;
  let deps = field.fielddependencies;
  if (deps == null || deps === '') return null;
  if (typeof deps === 'string') {
    try {
      deps = JSON.parse(deps);
    } catch {
      return null;
    }
  }
  const cfg = deps?.copyFromGroup;
  if (!cfg || typeof cfg.sourceGroup !== 'string' || !cfg.sourceGroup.trim()) return null;
  return cfg as CopyFromGroupConfig;
}

export function isCheckedValue(value: any): boolean {
  return value === true || value === 'true' || value === 1 || value === '1';
}

export function isSourceIndex(value: any): boolean {
  if (value === '' || value == null) return false;
  const text = String(value).trim();
  if (!/^\d+$/.test(text)) return false;
  return Number(text) >= 0;
}

export function resolveTargetOptionName(pair: CopyActiveOptionMap, sourceOptionName: string): string {
  const mapped = (pair?.optionMap || []).find((item) => item && item.from === sourceOptionName);
  return mapped ? mapped.to : sourceOptionName;
}

export function optionChildName(option: any): string | null {
  const entry = option?.values?.[0];
  if (entry == null) return null;
  if (typeof entry === 'string') return entry.trim() || null;
  if (typeof entry === 'object' && entry.name != null) return String(entry.name).trim() || null;
  return null;
}
